import React from 'react';
import { connect } from 'react-redux';
import TooltipBase from './TooltipBase';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import classNames from 'classnames';

const baseInfoTooltip = ({ toolTipText, isMobile, className, placement = 'right' }) => (
  <TooltipBase title={toolTipText} placement={isMobile ? 'top-end' : placement} className={className}>
    <InfoOutlined />
  </TooltipBase>
);

const withLabelInfoTooltip = props => (
  <div
    className={classNames({
      'tooltip-with-label': true,
      'inline-label': props.inlineLabel,
      [props.labelClassName]: props.labelClassName,
    })}>
    {props.labelText}
    {baseInfoTooltip(props)}
  </div>
);

const InfoTooltip = props => (props.labelText ? withLabelInfoTooltip(props) : baseInfoTooltip(props));

const mapStateToProps = state => ({
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InfoTooltip);



// WEBPACK FOOTER //
// ./src/ui/library/ToolTip/InfoTooltip.js